import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockCarrierIdFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  config: Partial<HttpClientConfig>
}

export function getOpenDockCarrierIdFactory({
  repository,
}: GetOpenDockCarrierIdFactoryDependencies) {
  return async function getOpenDockCarrierId({ shipmentUUID, config }: Params) {
    try {
      return await repository.getOpenDockCarrierId(shipmentUUID, config)
    } catch (error) {
      throw new Error('Could not get OpenDock carrier', { cause: error as Error })
    }
  }
}

export function getOpenDockCarrierId({ shipmentUUID, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetOpenDockCarrierId = getOpenDockCarrierIdFactory({
    repository,
  })
  return newGetOpenDockCarrierId({ shipmentUUID, config })
}
